var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_vm._t("default"),_vm._v(" "),_c('modal-container',[_c('continue-session-modal',{ref:"continueSession"})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }